import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { rideAPI } from '../../services/api';
import AppNavbar from '../../components/AppNavbar';
import SiteFooter from '../../components/SiteFooter';
import MobileBottomNav from '../../components/MobileBottomNav';
import LocationField from '../../components/LocationField';

// DOM order matters here: in an RTL flex row the first item renders
// rightmost, so ركشة goes first to end up on the right, تاكسي in the
// middle, حافلة last so it ends up on the left.
const VEHICLES = [
  { key: 'rickshaw', label: 'ركشة', icon: '🛺' },
  { key: 'taxi', label: 'تاكسي', icon: '🚕' },
  { key: 'bus', label: 'حافلة', icon: '🚌' },
];

const inputCls = 'w-full border-2 border-gray-200 hover:border-[#1E3A8A]/40 focus:border-[#1E3A8A] focus:ring-4 focus:ring-blue-100 rounded-xl px-4 py-2.5 text-sm transition-all outline-none';
const labelCls = 'block text-xs font-bold text-gray-600 mb-1.5';

const RideRequestNewPage = () => {
  const navigate = useNavigate();
  const isLoggedIn = !!JSON.parse(localStorage.getItem('passenger_user') || 'null')?.id;
  const [fromLabel, setFromLabel] = useState('');
  const [toLabel, setToLabel]     = useState('');
  const [fromLat, setFromLat] = useState(null);
  const [fromLng, setFromLng] = useState(null);
  const [toLat,   setToLat]   = useState(null);
  const [toLng,   setToLng]   = useState(null);
  const [vehicleCategory, setVehicleCategory] = useState(null);
  const [creating, setCreating] = useState(false);
  const [error, setError]       = useState('');

  const canSubmit = fromLabel.trim() && toLabel.trim() && vehicleCategory;

  const pickFrom = (lat, lng, label) => { setFromLat(lat); setFromLng(lng); setFromLabel(label); };
  const pickTo   = (lat, lng, label) => { setToLat(lat);   setToLng(lng);   setToLabel(label); };

  const handleCreate = async () => {
    if (!canSubmit) { setError('يرجى تحديد نقطة الانطلاق والوجهة ونوع المركبة'); return; }
    setCreating(true); setError('');
    try {
      const res = await rideAPI.createRequest({
        fromLabel, toLabel, vehicleCategory,
        fromLat: fromLat || undefined, fromLng: fromLng || undefined,
        toLat: toLat || undefined, toLng: toLng || undefined,
      });
      navigate(`/rides/requests/${res.data.data.id}`);
    } catch (err) {
      setError(err.response?.data?.message || 'تعذّر إرسال طلب المشوار');
    } finally { setCreating(false); }
  };

  useEffect(() => { if (!isLoggedIn) navigate('/login?from=/rides/new'); }, [isLoggedIn, navigate]);
  if (!isLoggedIn) return null;

  return (
    <div dir="rtl" className="min-h-screen bg-[#F5F9FF] pb-16">
      <AppNavbar />
      <div className="max-w-lg mx-auto px-4 py-6">
        <h1 className="text-xl font-black text-[#1E3A8A] mb-1">🚕 طلب مشوار</h1>
        <p className="text-sm text-gray-600 mb-6">حدد نقطة الانطلاق والوجهة — سترسل لك السائقون القريبون عروض أسعارهم</p>

        {error && <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl px-4 py-3 mb-4">{error}</div>}

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 space-y-4">
          {/* نوع المركبة first — the quickest, most glanceable choice, matches
              the "vehicle type at the top" layout the user asked for. */}
          <div>
            <label className={labelCls}>نوع المركبة</label>
            <div className="flex gap-2">
              {VEHICLES.map((v) => (
                <button key={v.key} type="button" onClick={() => setVehicleCategory(v.key)}
                  className={`flex-1 flex flex-col items-center gap-1 py-3 rounded-xl border text-xs font-bold transition-all ${
                    vehicleCategory === v.key ? 'bg-[#1E3A8A] text-white border-[#1E3A8A]' : 'bg-gray-50 text-gray-700 border-gray-300 hover:border-[#1E3A8A]/50'
                  }`}>
                  <span className="text-xl">{v.icon}</span> {v.label}
                </button>
              ))}
            </div>
          </div>
          <LocationField
            label="أنت الآن في" placeholder="مثال: الخرطوم 2"
            value={fromLabel} onChange={setFromLabel}
            lat={fromLat} lng={fromLng} onPick={pickFrom}
            inputClassName={inputCls} labelClassName={labelCls}
            autoCloseOnPick
          />
          <LocationField
            label="الوجهة" placeholder="مثال: المطار"
            value={toLabel} onChange={setToLabel}
            lat={toLat} lng={toLng} onPick={pickTo}
            inputClassName={inputCls} labelClassName={labelCls}
            autoCloseOnPick
          />
        </div>

        <button type="button" onClick={handleCreate} disabled={creating || !canSubmit}
          className="w-full mt-5 bg-[#1E40AF] hover:bg-[#1D4ED8] disabled:opacity-50 text-white font-black py-3.5 rounded-xl transition-all">
          {creating ? '...جارٍ الإرسال' : 'طلب مشوار'}
        </button>
      </div>
      <div className="hidden md:block"><SiteFooter navigate={navigate} /></div>
      <MobileBottomNav />
    </div>
  );
};

export default RideRequestNewPage;
